export const newsletter = {
  newsletter: {
    title: 'On y est presque!',
    subTitle:
      'Vérifiez votre boîte de réception. Nous vous avons envoyé un <br/> e-mail pour confirmer votre adresse e-mail.',
    steps: {
      stepOne: {
        title: '1. ouvrir le courriel',
        info: 'Vérifie dans ta boîte e-mail si tu as reçu le mail.',
      },
      stepTwo: {
        title: "2. confirmer l'inscription",
        info: 'Clique sur le lien dans le mail pour confirmer ton inscription.',
      },
      stepThree: {
        title: "3. profiter d'avantages exclusifs",
        info: "Tu recevras le bon de port gratuit avec l'e- mail de bienvenue.En tant que lecteur de la newsletter, tu profites d'informations exclusives en avant-première, d'offres attrayantes & de conseils pratiques sur la vie de famille.",
      },
    },
    unsubscribeSuccess: 'Tu as bien été désinscrit de notre newsletter.',
    noEmail: "Vous n'avez pas reçu d'e-mail?",
    noEmailDescription:
      "Il se peut que l'e- mail ait atterri dans ton dossier de spam.<br /> Le mieux est de vérifier tous les dossiers ou de s'adresser à: ",
    jakooServiceMailAddress: '<u>service@jako-o.de</u>',
    habaServiceMailAddress: '<u>kundenservice@haba.de</u>',
    tips: 'Notre conseil',
    tipsDescription:
      "Ajoute tout de suite l'adresse de l'expéditeur de notre newsletter à ton carnet d'adresses personnel afin de pouvoir recevoir correctement les newsletters. <br /><br /> Une erreur s'est glissée dans ton adresse e-mail? <br />  Tu pourras alors les saisir à nouveau.",
  },
};
